module.exports = __webpack_public_path__ + "static/media/Tea.2b3af7de.png";